export const getDays = (isWeekly: boolean) => {
    return isWeekly ? getWeeklyDays() : getMonthlyDays();
};

export const getWeeklyDays = (): { id: number; name: string; shortName: string }[] => {
    return [
        { id: 6, name: 'Sun', shortName: 'S' },
        { id: 0, name: 'Mon', shortName: 'M' },
        { id: 1, name: 'Tue', shortName: 'T' },
        { id: 2, name: 'Wed', shortName: 'W' },
        { id: 3, name: 'Thu', shortName: 'T' },
        { id: 4, name: 'Fri', shortName: 'F' },
        { id: 5, name: 'Sat', shortName: 'S' },
    ];
};
export const getMonthlyDays = (): { id: number; name: string; shortName: string }[] => {
    return [
        { id: 1, name: '1st day of the month', shortName: '1st' },
        { id: 15, name: '15th day of the month', shortName: '15th' },
    ];
};

export const getFrequency = (isWeekly: boolean) => {
    return isWeekly ? getWeeklyFrequency() : getMonthlyFrequency();
};

export const getWeeklyFrequency = (): { id: number; name: string }[] => {
    return [
        { id: 1, name: 'Every Week' },
        { id: 2, name: 'Every 2 Weeks' },
        { id: 4, name: 'Every Month' },
    ];
};
export const getMonthlyFrequency = (): { id: number; name: string }[] => {
    return [
        { id: 1, name: 'Every month' },
        { id: 2, name: 'Every 2 months' },
        { id: 3, name: 'Every 3 months' },
        { id: 4, name: 'Every 4 months' },
    ];
};
